module.exports = __webpack_public_path__ + "static/media/placeholder.d8dc71b5.svg";